import Cookies from 'js-cookie';
import axios from "axios";
import { axiosProtected, baseUrl } from '../config';
import { getPublicIp, getUserType, getAppSource } from '../helpers'

export const getDocumentTypeData =  async (data) => {
  try {
    const defaultReasonsData = await axiosProtected.post('/Document/DocumentType', data);
    return defaultReasonsData.data
  } catch (e) {    
    return null
  }
}

export const getDocumentList =  async (data) => {
  try {
    const defaultReasonsData = await axiosProtected.post('/Document/GetDocumentRequest', data);
    return defaultReasonsData.data
  } catch (e) {    
    return null
  }
}

export const submitDocumentRequest =  async (data) => {
    try {
      const defaultReasonsData = await axiosProtected.post('/Document/InsertDocumentRequest', data);
      return defaultReasonsData.data
    } catch (e) {    
      return null
    }
}

export const getRequestDetails =  async (data) => {
  try {
    const defaultReasonsData = await axiosProtected.post('/Document/RequestDetail', data);
    return defaultReasonsData.data
  } catch (e) {    
    return null
  }
}

export const downloadRequestDocument = async (data) => {
  const token = await Cookies.get('privateToken')
  try {
    const res = await axiosProtected({
        url: `${baseUrl}/Document/DownloadDocument`,
        method: 'POST',
        responseType: 'blob', 
        data: data,
        // headers: {
        //   Authorization: `Bearer ${token}`
        // }
      })
      return res
  } catch (e) {      
    return null
  }
}

export const submitRequestDetails = async (data) => {
  try {
    const defaultReasonsData = await axiosProtected.post('/Document/SubmitBorrowerResponse', data);
    return defaultReasonsData.data
  } catch (e) {    
    return null
  }
}

export const getFormLists = async (data) => {
  try {
    const defaultReasonsData = await axiosProtected.post('/Form/GetFormList', data);
    return defaultReasonsData.data
  } catch (e) {    
    return null
  }
}


//Get Support Categories

export const getSupportCategories =  async (data) => {
  try {
    const categoriesData = await axiosProtected.post('/Support/Categories', data);
    return categoriesData.data
  } catch (e) {    
    return null
  }
}

export const submitSupportTicket =  async (data) => {
  try {
    const insertData = await axiosProtected.post('/Support/InsertSupportRequest', data);
    return insertData.data
  } catch (e) {    
    return null
  }
}


//Upload support documents
export const uploadSupportDocuments = async (accountNumber,  file, count, replace, counter) => {
  try {
    const formData = new FormData();
    formData.append('accountNumber', accountNumber);
    formData.append('documentId', 0);
    formData.append('documentName', 'BORRCORR_' + counter + '.' + file.name.split(".").pop());
    formData.append('documentFile', file);
    formData.append('documentCount', replace ? count : count + 1);
    formData.append('privateLabelUrl', Cookies.get("privateLabelUrl"));
    formData.append('browser', Cookies.get("browser"));
    formData.append('appSource', getAppSource());
    formData.append('userType', getUserType());
    formData.append('ipAddress', Cookies.get('publicIp'));
    const response = await axiosProtected.post('/Support/uploadDocument', formData);
    return response.data;
  } catch (e) {
    return null
  }
}

//Delete support documents
export const deleteSupportDocuments = async (accountNumber, documentId) => {
  try {
    const data = {
    'accountNumber': accountNumber,
    'documentId': documentId,
    'privateLabelUrl': Cookies.get("privateLabelUrl"),
    'browser': Cookies.get("browser"),
    'appSource': getAppSource(),
    'userType': getUserType(),
    'ipAddress': Cookies.get('publicIp')
    }
    const response = await axiosProtected.post('/Support/DeleteDocument', data);
    return response.data;
  } catch (e) {
    return null
  }
}

//Download support documents
export const downloadSupportDocument = async (accountNumber, documentId) => {
  try {
    const data = {
      'accountNumber': accountNumber,
      'documentId': documentId,
      'privateLabelUrl': Cookies.get("privateLabelUrl"),
      'browser': Cookies.get("browser"),
      'appSource': getAppSource(),
      'userType': getUserType(),
      'ipAddress': Cookies.get('publicIp')
    }
    const response = await axiosProtected({
      url: `${baseUrl}/Support/DownloadDocument`,
      method: 'POST',
      responseType: 'blob', 
      data: data,
    })
    return response.data;
  } catch (e) {
    return null
  }
}

export const getSupportRequestLists =  async (data) => {
  try {
    const response = await axiosProtected.post('/Support/GetSupportRequest', data);
    return response.data
  } catch (e) {    
    return null
  }
}

export const getSupportRequestDetails =  async (data) => {
  try {
    const response = await axiosProtected.post('/Support/SupportRequestDetail', data);
    return response.data
  } catch (e) {    
    return null
  }
}

export const submitSupportTicketResponse = async (data) => {
  try {
    const response = await axiosProtected.post('/Support/SubmitSupportTicketResponse', data);
    return response.data
  } catch (e) {    
    return null
  }
}

export const submitReopenSupportTicket =  async (data) => {
  try {
    const reopenTicketData = await axiosProtected.post('/Support/SubmitSupportTicketResponse', data);
    return reopenTicketData.data
  } catch (e) {    
    return null
  }
}
